module.exports = __webpack_public_path__ + "static/media/20190201_154035.b0abb543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20190201_154035.jpg
// module id = 483
// module chunks = 0